/**
 * SIP 明细「类别」的中文标签 —— **唯一出处**（v0.68 从 `sipFormat.ts` 抽出）。
 *
 * ## 为什么要单独一个文件
 *
 * 「类别」在 v0.68 之后有**两个消费者**：
 *   · 下拉的**值**来自后台清单（`store/options.ts` → 接口 `sip_kind`）；
 *   · 下拉的**中文标签**来自本文件这张固定表。
 *
 * 而 `store/options.ts` 的出厂兜底需要「预置的 5 个值」—— 如果那张表还留在
 * `components/sip/sipFormat.ts` 里，`store → 组件` 就形成**反向依赖**，并且
 * `sipFormat → store`（要用 `useOptionValues`）会与它构成**循环 import**。
 * ⇒ 把「值与标签」下沉到 `lib/`，两个方向都只依赖这一处，谁也不依赖谁。
 *
 * ## 🔴 为什么值仍然是英文枚举
 *
 * `kind` 落在 `sip_drafts.items_json` 里、与识别链路的 `feature.kind` 同源
 * （`dimension / gdt / thread / reference / surface_roughness`）。改成中文值
 * 等于让「指导书里选的」与「识别写进来的」变成两套口径 —— 那是本项目头号坑。
 * ⇒ 界面显示中文，存储保持枚举；用户**新加**的类别通常是中文（外观/包装…），
 *    查不到标签就**原样显示**，绝不猜一个译名（同文件原有兜底纪律）。
 */

/** `kind` 全集的中文标签。键 = 内部枚举（与后端 `DEFAULT_OPTIONS['sip_kind']` 一致）。 */
export const KIND_ZH: Record<string, string> = {
  dimension: '尺寸',
  gdt: '形位公差',
  thread: '螺纹',
  reference: '基准',
  surface_roughness: '表面粗糙度',
};

/**
 * 出厂预置的 5 个值 —— **由 `KIND_ZH` 的键派生，不另抄一份**。
 * `store/options.ts` 在前端读不到后台清单时用它顶上（与后端 `DEFAULT_OPTIONS` 同源同序）。
 */
export const SIP_KIND_PRESET: string[] = Object.keys(KIND_ZH);

/** 值的显示名：认识的查表，不认识的**原样返回**（不猜、不留空白）。 */
export function kindLabel(value: string): string {
  const v = (value ?? '').trim();
  return KIND_ZH[v] ?? v;
}
